import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './custom-occurence.reducer';

export const CustomOccurenceDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const customOccurenceEntity = useAppSelector(state => state.customOccurence.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="customOccurenceDetailsHeading">
          <Translate contentKey="reachamyApp.customOccurence.detail.title">CustomOccurence</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{customOccurenceEntity.id}</dd>
          <dt>
            <span id="activityNumber">
              <Translate contentKey="reachamyApp.customOccurence.activityNumber">Activity Number</Translate>
            </span>
          </dt>
          <dd>{customOccurenceEntity.activityNumber}</dd>
          <dt>
            <span id="repeatEveryNth">
              <Translate contentKey="reachamyApp.customOccurence.repeatEveryNth">Repeat Every Nth</Translate>
            </span>
          </dt>
          <dd>{customOccurenceEntity.repeatEveryNth}</dd>
          <dt>
            <span id="weekORMonthORYear">
              <Translate contentKey="reachamyApp.customOccurence.weekORMonthORYear">Week OR Month OR Year</Translate>
            </span>
          </dt>
          <dd>{customOccurenceEntity.weekORMonthORYear}</dd>
          <dt>
            <span id="occurence">
              <Translate contentKey="reachamyApp.customOccurence.occurence">Occurence</Translate>
            </span>
          </dt>
          <dd>{customOccurenceEntity.occurence}</dd>
          <dt>
            <span id="endDate">
              <Translate contentKey="reachamyApp.customOccurence.endDate">End Date</Translate>
            </span>
          </dt>
          <dd>
            {customOccurenceEntity.endDate ? (
              <TextFormat value={customOccurenceEntity.endDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
        </dl>
        <Button tag={Link} to="/custom-occurence" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/custom-occurence/${customOccurenceEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default CustomOccurenceDetail;
